import React, { useState } from "react";
import PropTypes from "prop-types";
import { IconButton, Typography } from "@material-ui/core";
import { Drawer } from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import { useIntl } from "react-intl";
import injectSheet from "react-jss";

import { Flex } from "../../../../_common";
import ListaLeadsAtividades from "../components/ListaLeads/ListaLeadsAtividades";
import AbasDrawer from "./AbasDrawer";
import AbaObservacoes from "./AbaObservacoes";

const style = () => ({
  rootDrawer: { right: "unset" },
  containerTitulo: {
    height: 32,
    marginBottom: 16,
  },
  botaoAcao: {
    width: 32,
    height: 32,
  },
  listaLeads: {
    paddingTop: 24,
  },
});

function DrawerAtividadeEmMassa({
  aberto,
  contatosId,
  atividades,
  reloadContatos,
  onClose,
  cssDrawer,
  cssTitulo,
  classes,
  isEnvioWhatsApp,
}) {
  const intl = useIntl();
  const [active, setActive] = useState("detalhe");

  return (
    <Drawer className={classes.rootDrawer} anchor="right" open={aberto} disableEnforceFocus>
      <Flex flexDirection="column" className={cssDrawer}>
        <Flex justifyContent="space-between" alignItems="center" className={classes.containerTitulo}>
          <Flex justifyContent="flex-start">
            <Typography variant="h5" className={cssTitulo}>
              {isEnvioWhatsApp
                ? intl.formatMessage({
                    defaultMessage: "Envio de WhatsApp em massa",
                  })
                : intl.formatMessage({ defaultMessage: "Envio de e-mail em massa" })}
            </Typography>
          </Flex>
          <Flex justifyContent="flex-end">
            <Flex justifyContent="space-between">
              <Flex justifyContent="flex-end">
                <IconButton aria-label="Close" onClick={onClose} className={classes.botaoAcao}>
                  <CloseIcon />
                </IconButton>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <AbasDrawer active={active} setActive={setActive} isAtividadeEmMassa />
        <Flex flexDirection="column" className={classes.listaLeads}>
          {active === "detalhe" && (
            <ListaLeadsAtividades
              reloadContatos={reloadContatos}
              atividades={atividades}
              contatosId={contatosId}
              isEnvioWhatsApp={isEnvioWhatsApp}
            />
          )}
          {active === "observacoes" && <AbaObservacoes atividades={atividades} isAtividadeEmMassa />}
        </Flex>
      </Flex>
    </Drawer>
  );
}

DrawerAtividadeEmMassa.propTypes = {
  aberto: PropTypes.bool,
  contatosId: PropTypes.array,
  atividades: PropTypes.array,
  reloadContatos: PropTypes.bool,
  onClose: PropTypes.func,
  cssDrawer: PropTypes.string,
  cssTitulo: PropTypes.string,
  isEnvioWhatsApp: PropTypes.bool,
};

export default injectSheet(style)(DrawerAtividadeEmMassa);
